import Repeatable from './Repeatable';

export default Repeatable;
